// -- External libraries
import { mergeProps } from 'solid-js'

export const useCardAtomComponentController = (props) => {
    const defaultProps = {}
    const mergedProps = mergeProps(defaultProps, props)

    return {
        mergedProps,
    }
}
